import {Component, OnInit, Input} from '@angular/core';
import {IStage, ISpotWrapper, ISpot} from '../../../../shared/models/models';
import { EventService } from '../../../../shared/services/event.service';
import { ServerService } from '../../../../shared/services/server.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-line-chart-construction',
  templateUrl: './line-chart-construction.component.html',
  styleUrls: ['./line-chart-construction.component.scss']
})
export class LineChartConstructionComponent implements OnInit {

  @Input() spot: ISpot;

  livingComplexId: number;

  loading: boolean = false;
  activated: boolean = false;

  buildingPorcess: BuildProcess = { facts: [], versions: [], forecastDateTotalLagAndPercent: null, weather: [], troubleCount: [], stagePercent: [], set8: null};

  selectedStageNumber: number = null;
  dataLoader = new Subject<any>();
  selectedBuildindId: number;
  weatherTooltipView: boolean = false;


  constructor(private service: ServerService,
    private event: EventService) {
    }

  ngOnInit() {

    if(this.spot && typeof(this.spot.id) !== 'undefined') {
      this.selectedBuildindId = this.spot.id;
      this.loadDataBuildProcess(this.selectedBuildindId, null);
    }

  }

  noData: boolean;
  loadDataBuildProcess(selectedBuildindId: number, stageId: any) {
    this.loading = true;
    this.service.getLivingComplexInfo_BuildProcess2(selectedBuildindId, stageId).then(res => {
      this.buildingPorcess = res;
      if(this.buildingPorcess.set8 !== null && this.buildingPorcess.set8.temperature) {
        this.buildingPorcess.set8.temperature = Math.round(this.buildingPorcess.set8.temperature);
      }
      debugger;
      if (this.buildingPorcess.facts.length > 0 || this.buildingPorcess.versions.length > 0) {
        this.noData = false;
      } else {
        this.noData = true;
      }
      if(stageId !== null && this.stages.find(x => x.number === stageId).complete === 100) {
        this.buildingPorcess.troubleCount = this.buildingPorcess.troubleCount.filter(x => x.factorTypeID !== 2);
      }
      if(stageId === null && this.totalPercent.complete === 100){
        this.buildingPorcess.troubleCount = this.buildingPorcess.troubleCount.filter(x => x.factorTypeID !== 2);
      }

      if(stageId == null){
        this.loadDataBuildProcessPercent();
      }
      this.loading = false;
    });
  }

  getBuildingCausesType(cause){
    if(cause.factorTypeID === 2) {
      if(cause.dayCount === 0) {
        return 'weathergrey';
      }
      return 'weather';
    }else if(cause.factorTypeID === 1) {
      if(cause.dayCount === 0) {
        return 'buildinggrey';
      }
      return 'building';
    }else if(cause.factorTypeID === 3) {
      if(cause.dayCount === 0) {
        return 'stormgrey';
      }
      return 'storm';
    }else if(cause.factorTypeID === 4) {
      if(cause.dayCount === 0) {
        return 'employeegrey';
      }
      return 'employee';
    }
  }

  stages: StagePercent[] = [];
  totalPercent: { complete: any, deviationTypeID: number } = { complete: 0, deviationTypeID: 3 };
  loadDataBuildProcessPercent() {
    let stagesEx = this.spot.stages;
      // if (stagesEx && (typeof (stagesEx) !== "undefined")) {
      //   this.stages = stagesEx;
      //   let index = 0;
      //   let totalPer = null;
      //   this.stages.map(r => {
      //     if(r.complete !== null && r.number !== 8) {
      //       totalPer += r.complete;
      //     }
      //     index++;
      //   });
      //   let ttl = null;
      //   if (totalPer !== null ) {
      //     ttl = (totalPer / (this.stages.length-1));
      //   }
      //   this.totalPercent = { complete: ttl, deviationTypeID: this.getDeviationTypeByPercent(ttl) };
      // }

      if (stagesEx && (typeof (stagesEx) !== "undefined")) {
        this.stages = stagesEx;
        this.stages.forEach(s => {
          let findElement = this.buildingPorcess.stagePercent.find(e => e.stageID === s.number);
          if (findElement) {
            s.complete = findElement.completionPercent;
          } else {
            s.complete = null;
          }
        });
        this.totalPercent = {
          complete: this.buildingPorcess.forecastDateTotalLagAndPercent.totalPercent, 
          deviationTypeID: this.getDeviationTypeByPercent(this.buildingPorcess.forecastDateTotalLagAndPercent.totalPercent) 
        };
      }
  }

  // // selectedBuildingIndex: number;
  // selectedBuildindId: number;
  // selectBuilding(index: number) {
  //   this.selectedStageNumber = null;
  //   // this.selectedBuildingIndex = index;
  //   // this.selectedBuildindId = this.buildingsWithDeviations[index].id;
  //   this.loadDataBuildProcess(this.selectedBuildindId, null);
  //   this.loadDataBuildProcessPercent();
  // }

  getWeatherList() {
    if(this.buildingPorcess.weather.length > 0){
      this.weatherTooltipView = !this.weatherTooltipView;
    }
  }

  selectStage(index: any) {
    this.weatherTooltipView = false;
    if (index === 'sum') {
      this.selectedStageNumber = null;
      this.loadDataBuildProcess(this.selectedBuildindId, null);
    } else {
      this.selectedStageNumber = index;
      this.loadDataBuildProcess(this.selectedBuildindId, parseInt(index));
    }
  }

  getColorByDeviationTypeId(deviationTypeId) {
    return this.event.getColorByDeviationTypeID(deviationTypeId)[0];
  }

  getDeviationTypeByPercent(percent: any): number {
    if (percent >= 100) {
      return 0;
    }
    if (percent > 0 && percent < 100) {
      return 1;
    }
    if (percent == 0) {
      return 2;
    }
    return 3;
  }

  getTooltip(number: number) {
    let dic = [
      'Основания и фундаменты',
      'Несущие и огражд. конструкции выше отметки 0.000',
      'Внутренние стены и перегородки',
      'Окна и двери',
      'Внутренние системы',
      'Наружная отделка',
      'Внутренняя отделка',
      'Наружные сети (ИКИ)'
    ];
    return dic[number - 1];
  }

  isForecastDate(dateStr: string) {
    let curDate = new Date();
    let date = new Date(dateStr);
    curDate.setHours(0,0,0,0);
    date.setHours(0,0,0,0)
    if(curDate.getTime() <= date.getTime()){
      return true;
    }else {
      return false;
    }
  }

}

export interface StagePercent {
  number: number;
  complete: number;
  start_date?: number;
  end_date?: number;
  deviationTypeID?: number;
}
export interface BuildProcess {
  buildingID?: number;
  facts: FactsBuildProcess[];
  // forecastDate: Date;
  forecastDateTotalLagAndPercent: {
    forecastDate: Date,
    totalLag: number,
    totalPercent: number
  };
  versions: VersionsBuildProcess[];
  weather: any[];
  troubleCount: any[];
  stagePercent: {stageID: number, completionPercent: number}[];
  set8: any;
}

export interface FactsBuildProcess {
  completionPercent: number;
  factDate: Date;
  lag: number;
}
export interface VersionsBuildProcess {
  isLastVersion: boolean;
  planEndDate: Date;
  planStartDate: Date;
  versionID: number;
}
